import ChatMessageGroup, { generateMessageKey } from './ChatMessageGroup';
import ChatMessageNotice from './ChatMessageNotice';
import ChatMessageViewState, { ChatMessageType } from '../store/schema/ChatMessageViewState';
import { observer } from 'mobx-react-lite';
import loc from 'owa-localize';
import { ucmaSessionEnded } from '../strings.locstring.json';
import * as React from 'react';

export interface ChatMessageListProps {
    messages: ChatMessageViewState[];
    isAbandoned: boolean;
}

import styles from './ChatMessageList.scss';

const TIMEOUT_BEFORE_NEW_CHAT_GROUP = 300000; // 5 minutes

export default observer(function ChatMessageList(props: ChatMessageListProps) {
    const chatGroups: ChatMessageViewState[][] = [];
    let currentGroup = 0;
    let currentIndex = 0;

    const spacerDiv = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (spacerDiv.current) {
            spacerDiv.current.scrollIntoView(false);
        }
    });

    props.messages.forEach(element => {
        if (chatGroups.length == 0) {
            // base case: no current groups
            chatGroups.push([element]);
        } else {
            const comparisonMessage = chatGroups[currentGroup][currentIndex];
            if (
                // If it's not the same sender,
                // the timestamp exceeds our determined amount,
                // it's a non message,
                // or if it's a message and the preceeding item is a non message,
                // Break it into a new group.
                comparisonMessage.fromSipUri != element.fromSipUri ||
                comparisonMessage.timestamp + TIMEOUT_BEFORE_NEW_CHAT_GROUP < element.timestamp ||
                !isImType(element.messageType) ||
                (isImType(element.messageType) && !isImType(comparisonMessage.messageType))
            ) {
                currentGroup++;
                currentIndex = 0;
                chatGroups.push([element]);
            } else {
                currentIndex++;
                chatGroups[currentGroup].push(element);
            }
        }
    });
    return (
        <div className={styles.messageList}>
            {chatGroups.map(messages =>
                isImType(messages[0].messageType) ? (
                    <ChatMessageGroup messages={messages} key={generateMessageKey(messages[0])} />
                ) : (
                    <ChatMessageNotice
                        chatMessage={messages[0]}
                        key={generateMessageKey(messages[0])}
                    />
                )
            )}
            {props.isAbandoned && (
                <div className={styles.sessionEnded}>{loc(ucmaSessionEnded)}</div>
            )}
            <div ref={spacerDiv} className={styles.spacer}>
                {/* this div purposefully left blank */}
            </div>
        </div>
    );
});

function isImType(messageType: ChatMessageType) {
    return (
        messageType == ChatMessageType.InstantMessage ||
        messageType == ChatMessageType.InstantMessageFromToast
    );
}
